import Vue from 'vue';
import Vuex from 'vuex';
import vSelect from 'vue-select';
import accountInvestigationQuestions from './modules/accountInvestigationQuestions';
import accountInvestigationOnboarding from './modules/accountInvestigationOnboarding';
import mergeInvestigationQuestions from './modules/mergeInvestigationQuestions';
import suspiciousGroupJoin from './modules/suspiciousGroupJoin';
import credentials from './modules/credentials';
import creditCardQuestions from './modules/creditCardQuestions';
import onboardPreferences from './modules/onboardPreferences';
import session from './modules/session';
import inviteSession from './modules/inviteSession';
import cashflowView from './modules/cashflowView';
import cashflowTour from './modules/cashflowTour';
import signup from './modules/signup';
import genericError from './modules/genericError';
import selectedSources from './modules/selectedSources';
import activationSurvey from './modules/surveys/activationSurvey';
import accuracySurvey from './modules/surveys/accuracySurvey';
import churnSurvey from './modules/surveys/churnSurvey';
import memberInvite from './modules/memberInvite';
import customerState from './modules/customerState';
import onboarding from './modules/onboarding';
import subscription from './modules/subscription';
import subscriptionState from './modules/subscriptionState';
import optimisticChange from './modules/cashflow-app/optimisticChange';
import cashflowCategoryActions from './modules/cashflow-app/cashflowCategoryActions';
import editCashflow from './modules/cashflow-app/editCashflow';
import editTransaction from './modules/cashflow-app/editTransaction';
import applicationState from './modules/applicationState';
import churn from './modules/churn';
import creditCardDetails from './modules/creditCardDetails';
import loader from './modules/loader';
import websocket from './modules/websocket';
import balance from './modules/balance';
import login from './modules/login';
import leadQualification from './modules/leadQualification';
import referral from './modules/referral';
import incomeInvestigationQuestions from './modules/incomeInvestigationQuestions';
import expenseInvestigationQuestions from './modules/expenseInvestigationQuestions';
import onboardingState from './modules/onboardingState';
import promotions from './modules/promotions';
import sourceFields from './modules/sourceFields';

Vue.use(Vuex);
Vue.component('v-select', vSelect);

export default new Vuex.Store({
  modules: {
    accountInvestigationQuestions,
    accountInvestigationOnboarding,
    mergeInvestigationQuestions,
    suspiciousGroupJoin,
    credentials,
    creditCardQuestions,
    onboardPreferences,
    session,
    onboarding,
    inviteSession,
    cashflowView,
    cashflowTour,
    signup,
    login,
    genericError,
    selectedSources,
    activationSurvey,
    accuracySurvey,
    churnSurvey,
    memberInvite,
    subscription,
    subscriptionState,
    optimisticChange,
    cashflowCategoryActions,
    editCashflow,
    editTransaction,
    customerState,
    applicationState,
    churn,
    creditCardDetails,
    loader,
    websocket,
    leadQualification,
    balance,
    referral,
    incomeInvestigationQuestions,
    expenseInvestigationQuestions,
    onboardingState,
    promotions,
    sourceFields,
  },
});
